// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.notification-wrapper {
  position: relative;
  display: inline-block;
}

.notification-bell {
  cursor: pointer;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 21px;
  background-color: #f1f1f1;
  transition: background-color 0.2s;
  color: #333;
}

.notification-bell:hover {
  background-color: #e2e2e2;
}

.bell-img {
  width: 24px;
  height: 24px;
  display: block;
}

.notification-dot {
  position: absolute;
  top: 2px;
  right: 2px;
  width: 12px;
  height: 12px;
  background-color: #ff9600;
  border-radius: 50%;
  border: 2px solid #fff;
  box-sizing: content-box;
}

.notification-dropdown {
  position: absolute;
  right: 0;
  top: 50px;
  width: 350px;
  background: white;
  border-radius: 12px;
  box-shadow: 0px 8px 20px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  overflow: hidden;
  border: 1px solid #eee;
}

.dropdown-header {
  padding: 15px;
  border-bottom: 1px solid #eee;
}

.dropdown-header h5 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #333;
}

.notification-list {
  max-height: 400px;
  overflow-y: auto;
}

.notification-card {
  display: flex;
  justify-content: space-between;
  padding: 12px 15px;
  border-bottom: 1px solid #f9f9f9;
  cursor: pointer;
  transition: background-color 0.2s;
}

.notification-card:hover {
  background-color: #f5f5f5;
}

.notification-card.read {
  opacity: 0.6;
}

.notification-content {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}

.notification-icon-img {
  margin-top: 4px;
}

.notification-title {
  font-weight: 600;
  font-size: 14px;
  color: #333;
  margin-bottom: 2px;
}

.notification-desc {
  font-size: 13px;
  color: #666;
}

.notification-actions {
  display: flex;
  align-items: center;
}

.notification-empty {
  padding: 30px 20px;
  text-align: center;
  color: #666;
}

.notification-footer {
  padding: 12px 15px;
  background-color: #f9f9f9;
  border-top: 1px solid #eee;
  text-align: center;
  font-size: 13px;
}

.notification-footer label {
  cursor: pointer;
}

@media (max-width: 575.98px) {
  .notification-dropdown {
    position: fixed;
    top: 70px;
    left: 50%;
    right: auto;
    transform: translateX(-50%);
    width: calc(100vw - 24px);
    max-width: 350px;
    max-height: calc(100vh - 90px);
    overflow-y: auto;
  }
}
`, "",{"version":3,"sources":["webpack://./src/app/components/shared/notification-bell/notification-bell.component.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,iCAAiC;EACjC,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,4CAA4C;EAC5C,aAAa;EACb,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,0BAA0B;EAC1B,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;IACE,eAAe;IACf,SAAS;IACT,SAAS;IACT,WAAW;IACX,2BAA2B;IAC3B,yBAAyB;IACzB,gBAAgB;IAChB,8BAA8B;IAC9B,gBAAgB;EAClB;AACF","sourcesContent":[".notification-wrapper {\n  position: relative;\n  display: inline-block;\n}\n\n.notification-bell {\n  cursor: pointer;\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  border-radius: 21px;\n  background-color: #f1f1f1;\n  transition: background-color 0.2s;\n  color: #333;\n}\n\n.notification-bell:hover {\n  background-color: #e2e2e2;\n}\n\n.bell-img {\n  width: 24px;\n  height: 24px;\n  display: block;\n}\n\n.notification-dot {\n  position: absolute;\n  top: 2px;\n  right: 2px;\n  width: 12px;\n  height: 12px;\n  background-color: #ff9600;\n  border-radius: 50%;\n  border: 2px solid #fff;\n  box-sizing: content-box;\n}\n\n.notification-dropdown {\n  position: absolute;\n  right: 0;\n  top: 50px;\n  width: 350px;\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0px 8px 20px rgba(0, 0, 0, 0.15);\n  z-index: 1000;\n  overflow: hidden;\n  border: 1px solid #eee;\n}\n\n.dropdown-header {\n  padding: 15px;\n  border-bottom: 1px solid #eee;\n}\n\n.dropdown-header h5 {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 600;\n  color: #333;\n}\n\n.notification-list {\n  max-height: 400px;\n  overflow-y: auto;\n}\n\n.notification-card {\n  display: flex;\n  justify-content: space-between;\n  padding: 12px 15px;\n  border-bottom: 1px solid #f9f9f9;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.notification-card:hover {\n  background-color: #f5f5f5;\n}\n\n.notification-card.read {\n  opacity: 0.6;\n}\n\n.notification-content {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n}\n\n.notification-icon-img {\n  margin-top: 4px;\n}\n\n.notification-title {\n  font-weight: 600;\n  font-size: 14px;\n  color: #333;\n  margin-bottom: 2px;\n}\n\n.notification-desc {\n  font-size: 13px;\n  color: #666;\n}\n\n.notification-actions {\n  display: flex;\n  align-items: center;\n}\n\n.notification-empty {\n  padding: 30px 20px;\n  text-align: center;\n  color: #666;\n}\n\n.notification-footer {\n  padding: 12px 15px;\n  background-color: #f9f9f9;\n  border-top: 1px solid #eee;\n  text-align: center;\n  font-size: 13px;\n}\n\n.notification-footer label {\n  cursor: pointer;\n}\n\n@media (max-width: 575.98px) {\n  .notification-dropdown {\n    position: fixed;\n    top: 70px;\n    left: 50%;\n    right: auto;\n    transform: translateX(-50%);\n    width: calc(100vw - 24px);\n    max-width: 350px;\n    max-height: calc(100vh - 90px);\n    overflow-y: auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
